import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import React from 'react';
import 'semantic-ui-css/components/popup.min.css';
import { Popup, PopupProps } from 'semantic-ui-react';
import './Popup.scss';

type WebAppPopupProps = Pick<
  PopupProps,
  'trigger' | 'content' | 'header' | 'disabled' | 'position' | 'flowing' | 'style' | 'open' | 'onOpen' | 'onClose'
>;

/**
 * A popup wrapper for the semantic-ui-react popup class
 */
const PopupBase: React.FC<WebAppPopupProps> = ({
  trigger,
  content,
  header,
  disabled,
  position = 'bottom center',
  flowing = true,
  style,
  open,
  onOpen,
  onClose,
}) => {
  return (
    <Popup
      basic
      on="click"
      disabled={disabled}
      position={position}
      flowing={flowing}
      trigger={trigger}
      header={header}
      content={content}
      style={style}
      open={open}
      onOpen={onOpen}
      onClose={onClose}
    />
  );
};

const PopupSection = withInjectedProps(PopupBase);

export { PopupSection };
export default PopupSection;
